import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Postrequest, Putrequest } from '../../../../context/AxiosRequest';
import { ContextData } from '../../../../context/Context';
import { toast } from 'react-toastify';
import SoundAlert from '../../../../routes/SoundAlert';
import MailIcon from '@mui/icons-material/Mail';
import RejectionNote from './WorkflowNote';
import { set } from 'lodash';
import GetAdminCredentials from '../../../../context/GetAdminCredentials';




export default function SendRejectDocumentMssg({from,mssgData,verifierToken,file_token,applicanttoken}) {


  const [open, setOpen] = React.useState(false);
  const {accesstoken,UserTokens } = React.useContext(ContextData)
  const [disBTN, setDisBTN] = React.useState(false);
  const [userType,setUserType] = React.useState("")

   React.useEffect(()=>{
  
          (async ()=>{
  
                  GetAdminCredentials(UserTokens,accesstoken).then(res =>{
                       setUserType(res)
                  })
                    
          })()
  
    
  
      },[]) 
  
     

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = (event) => {

     setDisBTN(true);
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const formJson = Object.fromEntries(formData.entries());
    const report = formJson.report;
    const contactMethod = formJson.contactMethod;

    let data,response


      if(from === "applicantProfile"){

        data = {
         ...mssgData,
         mssg_subject: `Message from ${userType && userType[0]?.acct_typ} `,
         mssg_body: report,
         contact_method: contactMethod
       };
          
      }else{

        data = {
         applicant_token: applicanttoken,
         document_token: file_token,
         verifier_token: verifierToken,
         mssg: report

       };

      }

    (async function f() {
      try { 
          
           if(from === "applicantProfile"){
              response = await Postrequest(`auth/mssg_notfier`,data, accesstoken);
           }else{
              response = await Putrequest(`auth/reject_mssg_applicant_doc`,data, accesstoken);
           }
    

        if (response.status) {
          toast.success(response.textStatus);
          SoundAlert("success");
          setDisBTN(false);
          handleClose();
        } else if (!response.status) {
          
          toast.error(response.textStatus || "Request failed");
          setDisBTN(false);
          SoundAlert("error");
        }
      } catch (err) {

        console.error(err);
        toast.error("Network or server error");
        SoundAlert("error");
        }


    })();

   




  };

  return (
    <React.Fragment>
       <div className='flex'>
      <Button variant={from === "applicantProfile" ? "contained" : "outlined"} onClick={handleClickOpen}>
         {from === "applicantProfile" ? <span className='flex justify-center items-center'><MailIcon sx={{fontSize:"2em",color:"white"}} />{"Send Mail"}</span> : "Reject Document"}
      </Button>
       {
        from === "applicantProfile" &&
           <RejectionNote applicant_token={mssgData?.receiver_token} />
       }
    
       </div>

      {
        from === "applicantProfile" &&    <p className='text-xs italic mt-2'><b>Optional:</b> Provide reason considering some applicants need additional support and clarification.</p>
      }

      <Dialog open={open} onClose={handleClose}  
      
       fullWidth
       maxWidth="md"
      >
        {
          from === "applicantProfile" ?
          
              <DialogTitle>Send Mail</DialogTitle>
          :

            <DialogTitle>Reject Document</DialogTitle>
        }
        <DialogContent>
          <DialogContentText>
           {from === "applicantProfile" ? "Send a message." : "Please provide a reason for rejecting the document."}
          </DialogContentText>
          {/* set input limit in the text area */}
          <form onSubmit={handleSubmit} id="subscription-form">
            <div style={{ marginBottom: '16px', display: 'flex', gap: '16px' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <input type="radio" name="contactMethod" value="email" defaultChecked />
                Send Email
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <input type="radio" name="contactMethod" value="chatflow" />
                Chatflow
              </label>
            </div>
            <TextField
              autoFocus
              required
              margin="dense"
              id="report"
              name="report"
              label=""
              type="text"
              fullWidth
              variant="outlined"
              multiline
              rows={4}
              inputProps={{ maxLength: from === "applicantProfile" ? 1000 : 200 }} // Set the maximum length to 500 characters
            />
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          {
            from === "applicantProfile" ?
          <Button disabled={disBTN}   type="submit" form="subscription-form">
            Send Mail
          </Button>

          :

          <Button  type="submit" form="subscription-form">
              Reject Document
          
          </Button>

          }
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
